import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import "./tencent.scss"; // The styles we made earlier for the Tencent layout
import { Link, useNavigate } from "react-router-dom";


function Tencent() {
    const [selectedUser, setSelectedUser] = useState(null);
    const [users, setUsers] = useState([]); // Now part of component state

    const [valence, setValence] = useState(0);
    const [arousal, setArousal] = useState(0);
    

    
    // useEffect(() => {
    //   // const fetchUsers = async () => {
    //   //   try {
    //   //     const response = await fetch("https://i38yarrog2.execute-api.eu-west-2.amazonaws.com/status");
    //   //     const data = await response.json();
    //   //     setUsers(data.users || []); // Set users
    //   //   } catch (error) {
    //   //     console.log("Error fetching users: ", error);
    //   //   }
    //   // };
  
    //   // fetchUsers();
    //   // const timerId = setInterval(fetchUsers, 5000); // Poll every 5 seconds
    //   // return () => clearInterval(timerId); // Cleanup
    // }, []);

    useEffect(() => {
      const graphElement = document.querySelector('.va-graph');
      if (graphElement) {
          plotPointOnVAGraph(valence, arousal);
      }
    }, [valence, arousal]); // Run effect when valence or arousal changes

    const WS_URL = 'ws://34.46.237.197:8080';
    let ws = null;
    // const WS_URL = null;

    function convertToSVGCoordinates(arousal, valence) {
      // Given that SVG width and height is 200
      // Convert the arousal and valence range of [-1, 1] to [0, 200]
      const x = 100 + (valence * 100); 
      const y = 100 - (arousal * 100); // Subtract from 100 because SVG y-coordinate starts from the top
  
      return { x, y };
    }

    function getFlagText(arousal, valence) {
      if (arousal > 0 && valence > 0) {
          return "happy";
      }
      if (arousal > 0 && valence < 0) {
          return "upset";
      }
      if (arousal < 0 && valence > 0) {
          return "calm";
      }
      if (arousal < 0 && valence < 0) {
          return "bored";
      }
      return ""; // default case if needed
  }

    function plotPointOnVAGraph(arousal, valence) {
        const graphElement = document.querySelector('.va-graph');

        const padding = 20; // from .va-graph CSS
        const border = 1; // border width from .va-graph CSS

        const drawableWidth = graphElement.offsetWidth - 2 * (padding + border);
        const drawableHeight = graphElement.offsetHeight - 2 * (padding + border);
        
        // Convert the -1 to 1 range into 0 to 1 for easier calculation:
        // e.g., -1 becomes 0, 0 remains 0.5, and 1 becomes 1
        const normalizedArousal = (arousal + 1) / 2;  
        const normalizedValence = (valence + 1) / 2;

        // Determine the circle's radius based on the smaller dimension of the .va-graph
        const circleRadius = Math.min(drawableWidth, drawableHeight) / 2;

        // const circleRadius = Math.min(graphElement.offsetWidth, graphElement.offsetHeight) / 2;

        // Calculate the center of the drawable area within the .va-graph
        const centerX = padding + border + drawableWidth / 2;
        const centerY = padding + border + drawableHeight / 2;

        // Calculate x and y coordinates based on the circle quadrant
        // const x = normalizedArousal * circleRadius;
        // const y = circleRadius - (normalizedValence * circleRadius); 
        // Calculate x and y coordinates based on the circle quadrant
        let x = centerX + (normalizedArousal - 0.5) * drawableWidth;
        let y = centerY - (normalizedValence - 0.5) * drawableHeight;


        // Check if the point is inside the circle quadrant
        const distanceFromCenter = Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2));
        if (distanceFromCenter > circleRadius) {
            // Scale down the point to fit within the circle
            const scale = circleRadius / distanceFromCenter;
            x = centerX + (x - centerX) * scale;
            y = centerY + (y - centerY) * scale;
        }

        
        // Check if point already exists, if not create one
        let point = graphElement.querySelector('.va-point');
        if (!point) {
            point = document.createElement('div');
            point.classList.add('va-point');
            graphElement.appendChild(point);
        }

        // Set the point's position
        point.style.left = `${x}px`;
        point.style.top = `${y}px`;
    }
    
    // Using the function with fixed values:
    const fixedArousal = 1;  // example value
    const fixedValence = -0.5;  // example value
   

    function setupWebSocket() {
        ws = new WebSocket(WS_URL);

        ws.onopen = () => {
            console.log("Connected and waiting for messages...");
        };

        ws.onmessage = async (event) => {
            try {
                // Convert Blob to text
                const text = await event.data.text();
                const data = JSON.parse(text);
                
                if (data.valence && data.arousal) {
                    setValence(data.valence);
                    setArousal(data.arousal);
                } else {
                    // console.log("Received unhandled message:", data);
                }
            } catch (err) {
                console.error("Error processing message:", err);
            }
        };

        ws.onerror = (error) => {
            // console.log('WebSocket Error:', error);
        };

        ws.onclose = (event) => {
            if (event.wasClean) {
                console.log(`Closed cleanly, code=${event.code}, reason=${event.reason}`);
            } else {
                // console.log('Connection died');
                // Reconnect after some delay
                setTimeout(() => {
                    setupWebSocket();
                }, 5000);
            }
        };
    }

  // Initial WebSocket setup
  setupWebSocket();
  // console.log("Valence arousal", arousal, valence)
  // plotPointOnVAGraph(valence, arousal);
    
    const clearSelection = () => {
      setSelectedUser(null);
    };
    return (
      <div className="bgBlue p-relative h-100 p-4">
      <div className="container">
        <div id="user-channel" className="user-channel">
          <h2>User Channel</h2>
          {Array.isArray(users) && users.length > 0 ? (
            users.map((user, index) => (
              <div 
                key={index} 
                className="user-info" 
                onClick={() => setSelectedUser(user)}
              >
                <span className="user-name">{user.name}</span>
                <span className={`live-indicator ${user.isLive ? 'green' : 'red'}`}></span>
              </div>
            ))
          ) : (
            <p>whitefoxy</p>
          )}
        </div>
      <div className="va-graph-section">
        <div id="va-graph" className="va-graph">
              <svg width="100%" height="100%" viewBox="0 0 200 200" className="quadrant-graph">
                  {/* Y-Axis Line */}
                  <line x1="100" y1="0" x2="100" y2="200" stroke="#ccc" stroke-width="1" />
                  {/* X-Axis Line */}
                  <line x1="0" y1="100" x2="200" y2="100" stroke="#ccc" stroke-width="1" />

                  {/* Y-Axis Label */}
                  <text x="105" y="10" fill="#000" font-size="2" text-anchor="start">+1</text>
                  <text x="105" y="190" fill="#000" font-size="2" text-anchor="start">-1</text>
                  <text x="2" y="10" fill="#000" font-size="10" text-anchor="start">Arousal</text>

                  {/* X-Axis Label */}
                  <text x="10" y="95" fill="#000" font-size="2" text-anchor="start">-1</text>
                  <text x="180" y="95" fill="#000" font-size="2" text-anchor="start">+1</text>
                  <text x="190" y="198" fill="#000" font-size="8" text-anchor="start">Valence</text>
                  
                  {/* Circle */}
                  <circle cx="100" cy="100" r="100" fill="none" stroke="#ccc" stroke-width="0.5" />
                 
                 {/* Labels */}
                 <text x="69.22" y="15.43" fill="#888" font-size="5" text-anchor="middle">Fear</text>
                  <text x="130.78" y="15.43" fill="#888" font-size="5" text-anchor="middle">Surprised</text>
                  <text x="163.64" y="36.36" fill="#888" font-size="5" text-anchor="middle">Excited</text>
                  <text x="188.63" y="84.37" fill="#888" font-size="5" text-anchor="middle">Happy</text>
                  <text x="184.57" y="130.78" fill="#888" font-size="5" text-anchor="middle">Pleased</text>
                  <text x="157.85" y="168.94" fill="#888" font-size="5" text-anchor="middle">Relaxed</text>
                  <text x="115.63" y="188.63" fill="#888" font-size="5" text-anchor="middle">Sleepy</text>
                  <text x="67.51" y="189.27" fill="#888" font-size="5" text-anchor="middle">Tired</text> {/* Updated position */}
                  <text x="48.38" y="173.72" fill="#888" font-size="5" text-anchor="middle">Depressed</text>
                  <text x="15.43" y="130.78" fill="#888" font-size="5" text-anchor="middle">Sad</text>
                  <text x="15.43" y="69.22" fill="#888" font-size="5" text-anchor="middle">Disgust</text>
                  <text x="42.15" y="31.06" fill="#888" font-size="5" text-anchor="middle">Angry</text>
              
                  {/* Data Point */}
                  {/* {
                      valence !== null && arousal !== null ? (
                          (() => {
                              const { x, y } = convertToSVGCoordinates(arousal, valence);
                              return (
                                  <circle cx={x} cy={y} r="2" fill="blue" />
                              );
                          })()
                      ) : null
                  } */}
              </svg>

          <h3>{selectedUser ? `VA Graph for ${selectedUser.name}` : ""}</h3>
          {/* VA Graph will be populated here based on selectedUser */}
        </div>
        <button onClick={clearSelection}>Clear</button>
        <div id="text-flag" className="text-flag">
          {/* Your Text Flag Here */}
          {getFlagText(arousal, valence)}
        </div>
      </div>
    </div>
      </div>
    );
    
  } 
  export default Tencent;